<template>
  <div>
    <PaymentMethodList :showBackButton="false" :access="false"> </PaymentMethodList>
  </div>
</template>

<script>
const PaymentMethodList = () =>
  import("@/modules/Donors/PaymentInfoCollect/PaymentMethod.vue");
export default {
  name: "payment-req-list",
  components: {
    PaymentMethodList,
  },
};
</script>

<style scoped>
</style>